export const GET_SO = 'GET_SO';
export const GET_SO_SUCCESS = 'GET_SO_SUCCESS';
export const GET_SO_FAIL = 'GET_SO_FAIL';

export const GET_SO_RP = 'GET_SO_RP';
export const GET_SO_RP_SUCCESS = 'GET_SO_RP_SUCCESS';
export const GET_SO_RP_FAIL = 'GET_SO_RP_FAIL';

export const REBIND_SO_RP = 'REBIND_SO_RP';
export const REBIND_SO_RP_SUCCESS = 'REBIND_SO_RP_SUCCESS';
export const REBIND_SO_RP_FAIL = 'REBIND_SO_RP_FAIL';

export const GET_SO_FOR_REBIND = 'GET_SO_FOR_REBIND';
export const GET_SO_FOR_REBIND_SUCCESS = 'GET_SO_FOR_REBIND_SUCCESS';
export const GET_SO_FOR_REBIND_FAIL = 'GET_SO_FOR_REBIND_FAIL';
